import React from 'react';
import { makeStyles } from '@material-ui/core';
import SideBarRight from '../../components/SideBarRight';
import { Route, Switch, useLocation, useHistory, Redirect } from 'react-router';
import useCheckMobileScreen from '../../hooks/useWidth';
import { getClinicId } from '../../utils/storage';
import BreadCrumbs from '../../components/BreadCrumbs';
import { useEffect } from 'react';
import useRoutes from '../useRoutes';
import { useSelector, useDispatch } from 'react-redux';
import { getUserInfo } from '../../redux/User/UserAction';
import useCheckAccess from '../../hooks/useCheckAccess';
import NotFound from '../../components/NotFound';

const styles = makeStyles((theme) => ({
    mainContainer: {
        padding: '60px 40px 40px 40px',
        position: 'relative',
        // backgroundColor: '#f2f4fa',
        width: '100%',
        overflow: 'auto',
        [theme.breakpoints.down('1025')]: {
            padding: '0 !important'
        }
    },
    row: {
        [theme.breakpoints.up(1025)]: {
            display: 'flex',
            overflow: 'hidden',
            backgroundColor: '#f2f4fa',
            height: '100vh'
        }
    }
}));
const hasNumber = (string) => {
    return /\d/.test(string);
};
const MainRoutes = () => {
    const isMobile = useCheckMobileScreen();
    const classes = styles();
    const clinic = getClinicId();
    const { pathname } = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const pathNames = pathname.split('/')?.filter((item) => item);
    const existId = pathNames[0];
    const patientId = pathNames[2];
    const clinicId = hasNumber(existId) ? existId : clinic;
    // const hasAccess = !hasNumber(patientId) ? true : false;
    const activeCrumbs = !hasNumber(patientId) && !pathNames.includes('setting');
    const user = useSelector((state) => state.user.userInfo);
    const { mainAccess } = useCheckAccess();
    const { mainRoutes, allowedRoutes } = useRoutes();
    const routes = allowedRoutes(mainRoutes, mainAccess);
    const existRoute = mainRoutes
        ?.filter((item) => item.isMobile !== !isMobile)
        ?.some((item) => item.link === pathname);
    const hasAccess = routes
        ?.filter((item) => item.isMobile !== !isMobile)
        ?.some((item) => item.link === pathname);
    const visibleNotFound = !hasAccess && existRoute;

    useEffect(() => {
        dispatch(getUserInfo());
    }, []);

    useEffect(() => {
        if (!hasNumber(existId) && clinicId) {
            history.replace(`/${clinicId}/patients`);
        }
    }, [pathname, clinicId]);

    return (
        <>
            <div className={classes.row}>
                <SideBarRight />
                <div className={classes.mainContainer}>
                    {activeCrumbs && !isMobile && <BreadCrumbs />}
                    {user?.id && (
                        <Switch>
                            {routes
                                ?.filter((item) => item.isMobile !== !isMobile)
                                ?.map((route) => (
                                    <Route key={route.id} {...route} />
                                ))}
                            {visibleNotFound ? (
                                <NotFound />
                            ) : (
                                clinic && <Redirect from="*" to={`/${clinicId}/patients`} />
                            )}
                        </Switch>
                    )}
                </div>
            </div>
        </>
    );
};

export default MainRoutes;
